;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import RichText, { BLOCKS } from 'components/ui/RichText';
import Text from 'components/ui/Text';

import { useTheme } from 'hooks/useTheme';

import styles from './CoverSlide.module.scss';

const richTextHeadline = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text.Theme
                    as="p"
                    config={{
                        'makers-reserve': {
                            baseTheme: 'makers30',
                            themes: {
                                large: 'makers48',
                            },
                        },
                        default: {
                            baseTheme: 'displaySmall',
                            themes: {
                                large: 'displayMedium',
                            },
                        },
                    }}
                    className={styles.headline}
                    fixWidows
                >
                    {children}
                </Text.Theme>
            );
        },
    },
};

const richTextCopy = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text.Theme
                    as="p"
                    config={{
                        'makers-reserve': {
                            baseTheme: 'bodySmall',
                            themes: {
                                large: 'bodyMedium',
                            },
                        },
                        default: {
                            baseTheme: 'bodyXSmall',
                            themes: {
                                large: 'bodySmall',
                            },
                        },
                    }}
                    className={styles.copy}
                    fixWidows
                >
                    {children}
                </Text.Theme>
            );
        },
    },
};

const CoverSlide = ({
    eyebrow,
    headline,
    copy,
    portraitImage,
    landscapeImage,
    onClickStart,
    textColor,
}) => {
    eyebrow ??= 'pairings';

    const [globalTheme] = useTheme();

    return (
        <div
            style={{ '--textColor': `var(--colors-${textColor})` }}
            className={cx(styles.root, styles[`theme--${globalTheme}`])}
        >
            {landscapeImage?.url && portraitImage?.url && (
                <div className={styles.image}>
                    <Img
                        src={portraitImage.url}
                        width={portraitImage?.width}
                        height={portraitImage?.height}
                        fallbackImageWidth={768}
                        alt={portraitImage.description || ''}
                        customSources={[
                            {
                                breakpoint: 1920,
                                src: landscapeImage.url,
                                imageWidth: parseInt(1920 * 1.5),
                            },
                            {
                                breakpoint: 1440,
                                src: landscapeImage.url,
                                imageWidth: parseInt(1440 * 1.5),
                            },
                            {
                                breakpoint: 1024,
                                src: landscapeImage.url,
                                imageWidth: parseInt(1024 * 1.5, 10),
                            },
                            {
                                breakpoint: 768,
                                src: portraitImage.url,
                                imageWidth: parseInt(768 * 1.5),
                            },
                            {
                                src: portraitImage.url,
                                imageWidth: parseInt(767 * 1.5),
                            },
                        ]}
                    />
                </div>
            )}
            <div className={styles.inner}>
                <Text.Theme
                    as="p"
                    config={{
                        'makers-reserve': {
                            baseTheme: 'beverlyLabelMedium',
                            themes: {
                                large: 'beverlyLabelLarge',
                            },
                        },
                        default: {
                            baseTheme: 'labelLarge',
                            themes: {
                                large: 'labelLarge',
                            },
                        },
                    }}
                    className={styles.eyebrow}
                >
                    {eyebrow}
                </Text.Theme>
                <RichText richText={headline} overrides={richTextHeadline} />
                <RichText richText={copy} overrides={richTextCopy} />
                <ButtonCTA
                    className={styles.cta}
                    text="See Pairings"
                    style={
                        globalTheme === 'makers-reserve'
                            ? 'makersFilled-brown-gold'
                            : 'filled-cream-white'
                    }
                    onClick={onClickStart}
                />
            </div>
        </div>
    );
};

CoverSlide.propTypes = {
    eyebrow: PropTypes.string,
    headline: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired,
    copy: PropTypes.object.isRequired,
    portraitImage: PropTypes.object.isRequired,
    landscapeImage: PropTypes.object.isRequired,
    onClickStart: PropTypes.func.isRequired,
    textColor: PropTypes.string.isRequired,
};

export default CoverSlide;
